import React from 'react';
import Approuter from './component/router/Approuter';
import Navbar from './component/Navbar';

const App = () => {
    return (
        <div>
        <Navbar animationType="slide-down" />
            {/* <Navbar animationType="fade-in" />  */}
             {/* <Navbar animationType="scale-up" /> */}
            <Approuter /> 
        </div>
    );
}

export default App;
